<script>
import { mapGetters } from 'vuex'
import { useCases } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['account']),
  },

  methods: {
    getTasksPermissions({ task } = {}) {
      return useCases.tasks.getPermissions({
        currentAccount: this.account,
        task,
      })
    },
    canEditTask({ task } = {}) {
      return this.getTasksPermissions({ task }).edit
    },
    canDeleteTask({ task } = {}) {
      return this.getTasksPermissions({ task }).delete
    },
  },
}
</script>
